import { render, staticRenderFns } from "./FormsetItem.vue?vue&type=template&id=31b4aa5d&scoped=true"
import script from "./FormsetItem.vue?vue&type=script&lang=js"
export * from "./FormsetItem.vue?vue&type=script&lang=js"
import style0 from "./FormsetItem.vue?vue&type=style&index=0&id=31b4aa5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4aa5d",
  null
  
)

export default component.exports